import { Flame, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

export default function CheckoutCancelPage() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="p-3 bg-primary/20 rounded-xl">
            <Flame className="w-8 h-8 text-primary animate-pulse" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">
            myFit<span className="text-primary">Beats</span>
          </h1>
        </div>

        <div className="bg-card border border-border/50 rounded-xl p-8">
          <div className="flex justify-center mb-4">
            <XCircle className="w-12 h-12 text-muted-foreground" />
          </div>
          <h2 className="text-2xl font-bold mb-2" data-testid="text-cancel-title">Checkout Cancelled</h2>
          <p className="text-muted-foreground mb-6" data-testid="text-cancel-message">
            No worries! You can start your free trial anytime.
          </p>
          <div className="flex flex-col gap-3">
            <Button
              onClick={() => setLocation('/preferences')}
              data-testid="button-try-again"
            >
              Try Again
            </Button>
            <Button
              variant="ghost"
              onClick={() => setLocation('/')}
              data-testid="button-go-home"
            >
              Go to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
